// Shell-side view of the iframe-embedding URL params (issue #396).
//
// The webapp owns the full param set for its standalone entry (/webapp/). The shell
// only needs what it alone can act on: hiding its own chrome and
// pre-seeding the theme so there is no flash before the MFE mounts. Organization and
// language seeding stay in the webapp — its hooks read the same (shell) URL.

export type EmbedTheme = 'light' | 'dark';

// Tri-state, matching the webapp: only literal 'true'/'false' count; anything else
// (or absent) is undefined → embedding ignored.
function parseEmbedded(raw: string | null): boolean | undefined {
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return undefined;
}

export interface ShellEmbedParams {
  embedded?: boolean;
  theme?: EmbedTheme;
}

export function resolveShellEmbed(search: string = window.location.search): ShellEmbedParams {
  const params = new URLSearchParams(search);
  const embedded = parseEmbedded(params.get('embedded'));
  const themeRaw = params.get('theme');
  const theme = themeRaw === 'dark' || themeRaw === 'light' ? themeRaw : undefined;
  return { embedded, theme };
}
